export default __webpack_public_path__ + "static/media/connect-mobile.b078f850.png";